module.exports = __webpack_public_path__ + "img/white_drops.5cee58e8.png";